import React from 'react';
import BravoLogo from './BravoLogo';

// Full-viewport shell for a page that renders OUTSIDE the app shell — no sidebar, no header,
// no logged-in user required. Centres a brand lockup above whatever it is given, so a
// standalone state (sign-in blocked, maintenance, session expired) still reads as Bravo.
//
// Inside the app shell use the normal page header instead (see content.js / .page-head).
export default function StandalonePage({ children = null, wordmark = 'Bravo', className = '' }) {
  return (
    <div className={('bravo-ds bsp-page ' + className).trim()}>
      <div className='bsp-brand'>
        <BravoLogo className='bsp-logo' />
        {wordmark ? <div className='bsp-wordmark'>{wordmark}</div> : null}
      </div>
      {children}
    </div>
  );
}
